import {Trans} from '@lingui/macro';
import React, {ReactNode} from 'react';

import {tryParseUrl} from '../../../../libs/shared/helpers/src/browser/urlHelpers';
import {isDefined} from '../../../../libs/shared/helpers/src/typescript/typeHelpers';
import {OauthClientEditorState} from '../../editors/oauthClientEditor/oauthClientEditorState';

/*
 * Types.
 */

export enum OauthClientEditorFormErrorsEnum {
  INVALID_REDIRECT_URL = 'invalid_redirect_url',
}

type OauthClientChecker = (state: OauthClientEditorState) => OauthClientEditorFormErrorsEnum | undefined;

/*
 * Checkers.
 */

const ERROR_CHECKS: ReadonlyArray<OauthClientChecker> = [
  // Redirect URLs.
  ({oauthClientState}) => {
    const {redirectUrls} = oauthClientState;

    const hasErrors = !redirectUrls.every(redirectUrlIsValid);

    if (hasErrors) {
      return OauthClientEditorFormErrorsEnum.INVALID_REDIRECT_URL;
    }

    return undefined;
  },
];

/*
 * Helpers.
 */

export function computeOauthClientEditorFormErrors(
  state: OauthClientEditorState,
): ReadonlyArray<OauthClientEditorFormErrorsEnum> {
  return ERROR_CHECKS.map((checker) => checker(state)).filter(isDefined);
}

function redirectUrlIsValid(redirectUrl: string) {
  const url = tryParseUrl(redirectUrl);

  return Boolean(url);
}

/*
 * Labels.
 */

export const oauthClientEditorFormErrorLabels: Record<OauthClientEditorFormErrorsEnum, ReactNode> = {
  [OauthClientEditorFormErrorsEnum.INVALID_REDIRECT_URL]: (
    <Trans id="oauth-client-editor-footer-tooltip-warning-invalid-redirect-url">
      Each redirect URL must be valid
    </Trans>
  ),
};
